import type { Filter } from '../stores/filters';

export const SITE_ENGAGEMENT_ROOT_FILTERS = 'site_events_filter';

export const containsEngagementsFilters = (filters: Record<string, Filter>): boolean => {
  const fields = [
    'email_events_filter',
    'media_events_filter',
    'search_events_filter',
    'site_events_filter',
    'social_events_filter',
  ];

  return fields.some((field) => !!filters[field]?.enabled);
};
